import { FC } from 'react';

type Props = {
	className?: string;
};

const DashboardCircleIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M14.0257 8.94987C15.6687 8.94987 17.0007 7.61795 17.0007 5.97494C17.0007 4.33192 15.6687 3 14.0257 3C12.3827 3 11.0508 4.33192 11.0508 5.97494C11.0508 7.61795 12.3827 8.94987 14.0257 8.94987Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M5.97494 8.94987C7.61795 8.94987 8.94987 7.61795 8.94987 5.97494C8.94987 4.33192 7.61795 3 5.97494 3C4.33192 3 3 4.33192 3 5.97494C3 7.61795 4.33192 8.94987 5.97494 8.94987Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M14.0257 17.0002C15.6687 17.0002 17.0007 15.6682 17.0007 14.0252C17.0007 12.3822 15.6687 11.0503 14.0257 11.0503C12.3827 11.0503 11.0508 12.3822 11.0508 14.0252C11.0508 15.6682 12.3827 17.0002 14.0257 17.0002Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M5.97494 17.0002C7.61795 17.0002 8.94987 15.6682 8.94987 14.0252C8.94987 12.3822 7.61795 11.0503 5.97494 11.0503C4.33192 11.0503 3 12.3822 3 14.0252C3 15.6682 4.33192 17.0002 5.97494 17.0002Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
		</svg>
	);
};

export default DashboardCircleIcon;
